// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__dpMWk","paramInput":"JobSimulator_paramInput__2-YA4","input":"JobSimulator_input__s3Osr"};